// extracted by mini-css-extract-plugin
module.exports = {"component":"Read_component__1_H3a","small":"Read_small__bl19B","block":"Read_block__1K4tA"};